import { showLinkCopyDialog } from './linkCopyDialog';

export interface FolderGuestLinkCreateResult {
  guestUrl: string;
  guestInviteId: string;
}

export async function showFolderGuestLinkDialog(
  createInvite: () => Promise<FolderGuestLinkCreateResult>,
): Promise<void> {
  await showLinkCopyDialog(
    async () => {
      const created = await createInvite();
      return created.guestUrl;
    },
    {
      titleKey: 'info.owner.dialogTitle',
      warningKey: 'files.owner.guestLinkWarning',
      createdKey: 'info.owner.created',
      creatingTitleKey: 'files.owner.guestLinkCreating',
      creatingDetailKey: 'files.owner.guestLinkCreatingDetail',
    },
  );
}
